@use '@helsenorge/designsystem-react/scss/spacers' as spacers;

.videospiller {
  &--matrise {
    order: -1;
    margin-bottom: spacers.getSpacer('l');
  }
}
